import styled from 'styled-components'
import TemplateBox from '../components/TemplateBox'

export const StyledTemplateBox = styled(TemplateBox)`
  font-size: ${(props) => props.fontSize};
  padding: 20px;
`
